module.exports = new __parcel__URL__("error.b6351f9e.svg").toString();